require('./stylesheets/index.scss');
require('./stylesheets/_payslider.scss');
require('./widget-payments');

module.exports = 'widget-payments';



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/index.js
 ** module id = 303
 ** module chunks = 1
 **/